import { call, put, select, take, type Effect } from 'redux-saga/effects';
import fireErrorAnalytics from '@atlassian/jira-errors-handling/src/utils/fire-error-analytics.tsx';
import {
	ERROR_REPORTING_TEAM,
	PACKAGE_NAME,
	ENTITY,
} from '@atlassian/jira-portfolio-3-portfolio/src/common/view/constant.tsx';
import {
	CANCEL as CANCEL_CHANGE_STATUS,
	SUCCESS as SUCCESS_CHANGE_STATUS,
	FAIL as FAIL_CHANGE_STATUS,
	type LoadAction,
} from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/state/domain/update-jira/change-status/actions.tsx';
import { getPlan } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/query/plan/index.tsx';
import { remove as removeCommitWarning } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/state/domain/update-jira/warnings/actions.tsx';
import { removeFromChanges } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/state/domain/update-jira/changes/actions.tsx';
import { remove as removeOriginalIssue } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/state/domain/original-issues/actions.tsx';
import { toErrorID } from '../../util.tsx';
import { doResetIssueRequest } from '../../issue/index.tsx';

export function* doHandleChangeStatus({
	payload: { issueId },
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
}: LoadAction): Generator<Effect, void, any> {
	const changeStatusResult = yield take([
		SUCCESS_CHANGE_STATUS,
		CANCEL_CHANGE_STATUS,
		FAIL_CHANGE_STATUS,
	]);
	if (changeStatusResult.type === SUCCESS_CHANGE_STATUS) {
		// Transition screen modal directly communicates with Jira, so when the user submits it,
		// the status has changed in Jira. We should then reset the status in ARJ.
		const { id: planId, currentScenarioId: scenarioId } = yield select(getPlan);
		const body = {
			itemKeys: [issueId],
			planId,
			scenarioId,
			description: { status: { reset: true }, statusTransition: { reset: true } }, // hardly reset the issue status in the BE
		};
		yield call(doResetIssueRequest, body);
		yield put(removeCommitWarning({ category: ENTITY.ISSUE, itemId: issueId }));
		yield put(removeFromChanges({ issueId }));
		yield put(removeOriginalIssue([issueId]));
	} else if (changeStatusResult.type === FAIL_CHANGE_STATUS) {
		const error = new Error('Jira failed to transition the status');
		fireErrorAnalytics({
			error,
			meta: {
				id: toErrorID(error, 'show-change-status-screen-failed'),
				packageName: PACKAGE_NAME,
				teamName: ERROR_REPORTING_TEAM,
			},
			sendToPrivacyUnsafeSplunk: true,
		});
	}
}
